import React from 'react';

const FadeIn = ({ children, show = true, delay = 0 }) => {
  return (
    <div
      style={{
        animation: show ? `fadeIn 300ms ease-out ${delay}ms both` : 'fadeOut 150ms ease-in both',
        width: '100%',
      }}
    >
      {children}
    </div>
  );
};

// CSS animace - BEZ posunu (translateY removed)
if (typeof document !== 'undefined') {
  const styleTag = document.createElement('style');
  styleTag.innerHTML = `
    @keyframes fadeIn {
      from { 
        opacity: 0; 
      }
      to { 
        opacity: 1; 
      }
    }
    
    @keyframes fadeOut {
      from { 
        opacity: 1;
      }
      to { 
        opacity: 0;
      }
    }
  `;
  if (!document.getElementById('fade-animations')) {
    styleTag.id = 'fade-animations';
    document.head.appendChild(styleTag);
  }
}

export default FadeIn;
